<div class="nav-item">
    <div class="nav-item__label"><ng-content></ng-content></div>
</div>
